import { AuthService } from '../auth/auth.service';

import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, UrlSegment, CanActivate, RouterStateSnapshot } from '@angular/router';




@Injectable({ providedIn: 'root' })
export class AppGuard implements CanActivate {
    constructor(
        private authService: AuthService
    ) {}

    canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const user = this.authService.currentUserValue;
      let roles = route.data.roles as Array<string>;
      if(roles.includes(user.modelRole)) {
        return true;
      }
      alert('You are not authorised to visit this page');
      return false;
  }
}
